"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class StatusController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            getPublic: 'v1/status/public',
            getVerbose: 'v1/status?verbose=true',
            get: 'v1/status',
        };
    }
    get(mode) {
        return this.manager.get({
            url: mode === 'private' ? this.endpoints.get : this.endpoints.getPublic,
        });
    }
    getVerbose() {
        return this.manager.get({
            url: this.endpoints.getVerbose,
        });
    }
}
exports.default = StatusController;
